export default __webpack_public_path__ + "static/media/white-coin-stacks-arrow-up.65215665.png";